import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IGroup } from "@formant/core/model/IGroup";

import { appStore, groupStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    group: IGroup;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove group"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { group } = this.props;
        const { name, id } = group;
        const message = <p>Delete group "{name}"?</p>;
        appStore.setConfirm({
            title: "Delete Group",
            message,
            onOk: async () => {
                await groupStore.disable(defined(id));
                appStore.setSnackbar("Group deleted");
            },
        });
    };
}
